import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 52px 32px;
  background-color: #000;
  text-align: center;
`;

export const Title = styled.h4`
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Note = styled.p`
  max-width: 530px;
  color: #fff;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;
